<template>
  <nav class="nav">
    <div>
      <div class="logo">
        <router-link to="/index">
          <img src="~images/base/logo.png"
               alt="">
        </router-link>
      </div>
      <div class="nav-right">
        <ul>
          <router-link to="/index"
                       tag="li">
            <span>首页</span>
          </router-link>
          <router-link to="/about"
                       tag="li">
            <span>关于我们</span>
          </router-link>
          <router-link to="/coreTechnology"
                       tag="li">
            <span>核心技术与产品</span>
          </router-link>
         <!--  <router-link to="/product"
                       tag="li">
            <span>核心产品</span>
          </router-link> -->
          <!-- <router-link to="/columns"
                       tag="li">
            <span>精选栏目</span>
          </router-link> -->
          <li class="hove-tag">
            <router-link to="/solution/digitalize"
                         tag="li">
              <span>数字化行业解决方案</span>
            </router-link>

            <div class="down-box">
              <div class="dl-box">
                <dl>
                  <dt>
                    <router-link to="/solution/digitalize">数字化解决方案</router-link>
                  </dt>
                  <dd>
                    <router-link to="/solution/digitalize">数据中台解决方案</router-link>
                  </dd>
                </dl>
                <dl>
                  <dt>
                    <router-link to="/solution/blockchain">区块链解决方案</router-link>
                  </dt>
                  <dd>
                    <div @click="onbtnblockchain(0)">数字政务解决方案</div>
                    <!-- <router-link :to="{path:'/solution/blockchain',query:{id:0}}">数字政务解决方案</router-link> -->
                  </dd>
                  <dd>
                    <div @click="onbtnblockchain(1)">非现场监管解决方案</div>
                    <!-- <router-link :to="{path:'/solution/blockchain',query:{id:1}}">非现场监管解决方案</router-link> -->
                  </dd>
                  <dd>
                    <div @click="onbtnblockchain(2)">供应链金融解决方案</div>
                    <!-- <router-link :to="{path:'/solution/blockchain',query:{id:2}}">供应链金融解决方案</router-link> -->
                  </dd>
                </dl>
                <dl>
                  <dt>
                    <router-link to="/solution/finance">金融科技解决方案</router-link>
                  </dt>
                  <dd>
                    <div @click="onbtn(0)">决策引擎解决方案</div>
                    <!-- <router-link :to="{path:'/solution/finance',query:{id:0}}">决策引擎解决方案</router-link> -->
                  </dd>
                  <dd>
                    <div @click="onbtn(1)">自动化建模解决方案</div>
                    <!-- <router-link :to="{path:'/solution/finance',query:{id:1}}">自动化建模解决方案</router-link> -->
                  </dd>
                  <dd>
                    <div @click="onbtn(2)">智能风控解决方案</div>
                    <!-- <router-link :to="{path:'/solution/finance',query:{id:2}}">智能风控解决方案</router-link> -->
                  </dd>
                </dl>

                <dl class="last-dl">
                  <dt>12333333333</dt>
                  <dd>
                    <!-- <div @click="onbtn(3)">助贷平台解决方案</div> -->
                    <!-- <router-link :to="{path:'/solution/finance',query:{id:3}}">助贷平台解决方案</router-link> -->

                  </dd>
                  <dd>
                    <div  @click="onbtn(3)">智慧营销解决方案</div>
                    <!-- <router-link :to="{path:'/solution/finance',query:{id:4}}">智慧营销解决方案</router-link> -->

                  </dd>
                </dl>
              </div>
            </div>
          </li>

          <router-link to="/information"
                       tag="li">
            <span>行业资讯</span>
          </router-link>

        </ul>

      </div>

    </div>

  </nav>
</template>

<script>
export default {
  name: 'UmfHeader',
  props: {
  },
  methods: {
    onbtnblockchain(id) {
      
      if(this.$route.path != '/solution/blockchain') {
        this.$router.replace('/solution/blockchain?id=' + id)
      } 
      this.$emit('changeId',id)
    },
    onbtn(id) {
      if(this.$route.path != '/solution/finance') {
        this.$router.replace('/solution/finance?id=' + id)
      } 
      this.$emit('changeId',id)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav {
  height: 70px;
  background: rgba(0, 0, 0, 0.3);
  position: absolute;
  width: 100%;
  z-index: 3;

  &:hover {
    background: rgba(0, 0, 0, 1);
  }
  .logo {
    float: left;
    padding-left: 100px;
    padding-top: 13px;
  }
  .nav-right {
    float: right;
    color: #ffffff;
    padding-right: 105px;
    ul {
      li {
        float: left;
        cursor: pointer;
        text-align: center;
        span {
          display: block;
          line-height: 70px;
          font-size: 16px;
          padding: 0 0px;
        }
        width: 166px;
        &.hove-tag {
          width: 250px;
          li {
            width: 215px;
          }
        }
        &:hover {
          span {
            transition: all 0.2s linear;
            color: #f8555c;
          }
        }
        &.router-link-active {
          span {
            transition: all 0.2s linear;
            color: #f8555c;
          }
        }

        &.hove-tag:hover {
          .down-box {
            display: block;
          }
        }
      }
    }
  }
  .down-box {
    background: #000000;
    display: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 70px;
    border-top: 1px solid #292b2f;
    color: #ffffff;
    text-align: right;
    padding-right: 105px;
    .dl-box {
      display: inline-block;
      dl {
        float: left;
        padding: 40px 26px;
        padding-bottom: 20px;
        &.last-dl {
          dt {
            visibility: hidden;
          }
        }
        dt {
          cursor: pointer;
          font-size: 16px;
          height: 35px;
          margin-bottom: 20px;
          text-align: left;
          position: relative;
          padding-left: 10px;
          border-bottom: 1px solid #2a2c30;
          &::before {
            width: 3px;
            height: 20px;
            background: #ff0000;
            content: "";
            position: absolute;
            top: 3px;
            left: 0;
          }
          &:hover {
            a {
              color: #f8555c;
              transition: all 0.2s linear;
            }
          }
          .router-link-exact-active {
            color: #f8555c;
          }
        }
        dd {
          .router-link-exact-active {
            color: #f8555c;
          }
          &:hover {
            a,div {
              color: #f8555c;
              transition: all 0.2s linear;
            }
          }
          padding-bottom: 20px;
          cursor: pointer;
          font-size: 14px;
          text-align: left;
          padding-left: 10px;
        }
      }
    }
  }
}
</style>